import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';

function random(min,max){ return Math.random()*(max-min)+min; }

export default function AmbientParticlesLayer({ count=24 }) {
  const particles = useMemo(()=> Array.from({ length:count }).map((_,i)=>({
    id:i,
    x: random(0,100),
    y: random(0,100),
    size: random(4,14),
    delay: random(0,8),
    duration: random(12,26),
    opacity: random(0.15,0.45)
  })),[count]);
  return (
    <Box aria-hidden='true' sx={{ position:'absolute', inset:0, overflow:'hidden', pointerEvents:'none' }}>
      {particles.map(p => (
        <Box key={p.id} component={motion.span}
          initial={{ opacity:0 }}
          animate={{ opacity:p.opacity, y:[0,-12,0] }}
          transition={{ delay:p.delay, duration:p.duration, repeat:Infinity, ease:'easeInOut' }}
          sx={{ position:'absolute', left:`${p.x}%`, top:`${p.y}%`, width:p.size, height:p.size, borderRadius:'50%', background:`radial-gradient(circle at 30% 30%, rgba(20,184,141,0.8), rgba(20,184,141,0.05))`, filter:'blur(1px)' }}
        />
      ))}
    </Box>
  );
}
